import React from 'react';
import { Helmet } from 'react-helmet-async';

const MatrimonyPage = ({ city, metaTitle, metaDescription, content }) => {
    return (
        <>
            <Helmet>
                <title>{metaTitle}</title>
                <meta name="description" content={metaDescription} />
                <meta name="keywords" content={`${city} matrimony, ${city} marriage, ${city} brides, ${city} grooms, matrimony service`} />

                {/* Open Graph tags for social sharing */}
                <meta property="og:title" content={metaTitle} />
                <meta property="og:description" content={metaDescription} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={window.location.href} />

                {/* Canonical URL */}
                <link rel="canonical" href={window.location.href} />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "ProfessionalService",
                        "name": `${city} Matrimony - ForeverUnion`,
                        "image": "https://incomparable-puffpuff-1c57a9.netlify.app/logo192.png",
                        "url": window.location.href,
                        "telephone": "+91-1234567890",
                        "address": {
                            "@type": "PostalAddress",
                            "addressLocality": city,
                            "addressCountry": "IN"
                        },
                        "priceRange": "$$"
                    })}
                </script>
            </Helmet>

            <div className="bg-white">
                {/* Hero Section */}
                <div className="relative bg-gradient-to-r from-pink-500 to-purple-600 text-white py-20 px-4">
                    <div className="container mx-auto text-center relative z-10">
                        <h1 className="text-4xl md:text-5xl font-bold mb-4 drop-shadow-md">
                            Find Your Soulmate in {city}
                        </h1>
                        <p className="text-xl md:text-2xl opacity-90 mb-8 max-w-2xl mx-auto">
                            The most trusted {city} matrimony service with thousands of verified profiles.
                        </p>
                        <div className="flex justify-center space-x-4">
                            <button className="bg-white text-pink-600 px-8 py-3 rounded-full font-bold shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
                                Register Free
                            </button>
                        </div>
                    </div>
                    {/* Decorative background pattern could go here */}
                    <div className="absolute inset-0 bg-black opacity-10"></div>
                </div>

                {/* Dynamic Content Section */}
                <div className="container mx-auto px-4 py-16">
                    <div className="prose prose-lg max-w-4xl mx-auto text-gray-700">
                        {content || (
                            <div>
                                <h2 className="text-3xl font-bold text-gray-800 mb-6">Why Choose Our {city} Matrimony Service?</h2>
                                <p className="mb-6">
                                    Are you looking for a suitable bride or groom in {city}? You've come to the right place.
                                    We understand that finding the perfect partner is one of the most important decisions of your life.
                                    Our platform is designed to make your search for a life partner in {city} simple, safe, and successful.
                                </p>

                                <div className="grid md:grid-cols-2 gap-8 my-12 not-prose">
                                    <div className="bg-pink-50 p-6 rounded-xl border border-pink-100">
                                        <h3 className="text-xl font-bold text-pink-700 mb-2">Verified Profiles</h3>
                                        <p className="text-gray-600">All profiles are manually screened to ensure you meet genuine people looking for marriage.</p>
                                    </div>
                                    <div className="bg-purple-50 p-6 rounded-xl border border-purple-100">
                                        <h3 className="text-xl font-bold text-purple-700 mb-2">Privacy Control</h3>
                                        <p className="text-gray-600">You have complete control over who can see your photos and contact information.</p>
                                    </div>
                                </div>

                                <h3 className="text-2xl font-bold text-gray-800 mb-4">Success Stories from {city}</h3>
                                <p>
                                    Thousands of happy couples have found each other through our {city} matrimony service.
                                    From North {city} to South {city}, we connect hearts across the city.
                                    Join today and be our next success story!
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MatrimonyPage;
